import { useReducer } from 'react';

interface ThanksPageState {
  monthRate: number;
  runningTime: number;
  showPage: boolean;
  eingabeB6: number;
  isCalculationValid: boolean;
  isQuizShown: boolean;
}

type ThanksPageAction =
  | {
      type: 'SET_CALCULATION_RESULT';
      payload: { monthlyRate: number; term: number; isCalculationValid: boolean; eingabeB6: number };
    }
  | { type: 'SHOW_PAGE' }
  | { type: 'SHOW_QUIZ' }
  | { type: 'HIDE_QUIZ' };

const initialThanksPageState: ThanksPageState = {
  monthRate: 0,
  runningTime: 0,
  showPage: false,
  eingabeB6: 0,
  isCalculationValid: false,
  isQuizShown: false,
};

const thanksPageReducer = (state: ThanksPageState, action: ThanksPageAction): ThanksPageState => {
  switch (action.type) {
    case 'SHOW_PAGE':
      return {
        ...state,
        showPage: true,
      };
    case 'SET_CALCULATION_RESULT':
      return {
        ...state,
        monthRate: action.payload.monthlyRate,
        runningTime: action.payload.term,
        isCalculationValid: action.payload.isCalculationValid,
        eingabeB6: action.payload.eingabeB6,
        showPage: true,
      };
    case 'SHOW_QUIZ':
      return {
        ...state,
        isQuizShown: true,
      };
    case 'HIDE_QUIZ':
      return {
        ...state,
        isQuizShown: false,
      };
    default:
      return state;
  }
};

export default function useThanksPageStore() {
  const [state, dispatch] = useReducer(thanksPageReducer, initialThanksPageState);

  return {
    state,
    setState: dispatch,
  };
}
